import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const token = this.authService.getToken();

        if (!token) {
            this.handleUnauthenticated();
            return false;
        }

        try {
            const decodedToken: any = jwtDecode(token);

            const isExpired = decodedToken.exp * 1000 < Date.now();

            if (isExpired) {
                this.handleUnauthenticated('Session expired');
                return false;
            }

            // 👉 Verifica se a rota tem restrição de roles
            const expectedRoles = (route.data['roles'] as string[] | []).map(
                (role: string) => role.toUpperCase()
            );

            if (expectedRoles && expectedRoles.length > 0) {
                // 🔀 Verifica as roles do localStorage ou do token
                const userRoles = JSON.parse(localStorage.getItem('roles') || '[]');

                // 📍 Validação extra: confere se roles do localStorage batem com o token (proteção extra)
                const tokenRoles = decodedToken.roles || [];
                const validRoles = userRoles.every((role: string) => tokenRoles.includes(role));

                const hasRole = expectedRoles.some(role => userRoles.includes(role));

                if (!hasRole || !validRoles) {
                    this.router.navigate(['/public/access']);
                    return false;
                }
            }

            return true;

        } catch (error) {
            this.handleUnauthenticated('Invalid token');
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.canActivate(childRoute, state); // ✅ reutiliza a lógica do canActivate
    }

    private handleUnauthenticated(reason: string = 'Unauthorized') {
        console.warn(`Access denied: ${reason}`);
        this.router.navigate(['/public/login']);
    }
}
